import React, { Component, CSSProperties } from 'react'
import { DownOutlined, CloseOutlined } from '@ant-design/icons';
import { Button, Modal, ModalProps } from 'antd';
import Draggable from 'react-draggable';
import './DragModal.less';

interface IProps {
    visible?: boolean
    title?: string
    onClose?: () => void
    wrapClassName?: string
    width?: number
    destroyOnClose?: boolean
    centered?: boolean
    forceRender?: boolean
    dragForbidden?: boolean
    showCloseIcon?: boolean
    showHeader?: boolean
    mask?: boolean
    style?: CSSProperties
    children?: React.ReactNode  //<DragModal/> 
    closeIcon?: React.ReactNode
    getContainer?: ModalProps['getContainer']
}

export default class DragModal extends Component<IProps> {
    draggleRef = React.createRef<any>();
    static defaultProps = {
        centered: true,
        forceRender: false,
        dragForbidden: false,
        showCloseIcon: true,
        showHeader: true,
        mask: false,
        getContainer: () => document.body,
    }

    state = {
        modalDragDisabled: true,
        bounds: { left: 0, top: 0, bottom: 0, right: 0 },
    }

    onModalDragStart = (event, uiData) => {
        if (this.props.dragForbidden) return;
        const { clientWidth, clientHeight } = window?.document?.documentElement;
        const targetRect = this.draggleRef?.current?.getBoundingClientRect();
        this.setState({
            bounds: {
                left: -targetRect?.left + uiData?.x,
                right: clientWidth - (targetRect?.right - uiData?.x),
                top: -targetRect?.top + uiData?.y,
                bottom: clientHeight - (targetRect?.bottom - uiData?.y),
            },
        });
    }

    onCancel = (e) => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    render() {
        const ModalDragger = (
            <div
                className="modal-dragger"
                onMouseOver={() => {
                    if (this.state.modalDragDisabled) {
                        this.setState({ modalDragDisabled: false })
                    }
                }}
                onMouseOut={() => {
                    this.setState({ modalDragDisabled: true })
                }}>
                <span className='modal-title' style={{ userSelect: 'none' }}>{this.props.title}</span>
                <span className="fill-remaining-space"></span>
                {/* {(this.props.showCloseIcon) && (
                    <CloseOutlined className="modal-close" onClick={this.onCancel} />
                )} */}
                {(this.props.showCloseIcon) && (
                    <button onClick={this.onCancel} className='ant-modal-close'>
                        <span className='ant-modal-close-x'>
                            {this.props.closeIcon || (
                                <CloseOutlined className="modal-close"/>
                            )}

                        </span>
                    </button>
                )}
            </div>
        )

        return (
            <Modal
                getContainer={this.props.getContainer}
                open={this.props.visible}
                // onCancel={this.onCancel}
                title={this.props.showHeader ? ModalDragger : null}
                width={this.props.width || 520}
                mask={this.props.mask}
                maskClosable={false}
                // transitionName=""
                centered={this.props.centered}
                destroyOnClose={this.props.destroyOnClose || false}
                wrapClassName={`${this.props.wrapClassName || ''} drag-modal`}
                closable={false}
                footer={null}
                style={this.props.style || null}
                forceRender={this.props.forceRender}
                modalRender={modal => (
                    <Draggable
                        disabled={this.state.modalDragDisabled || this.props.dragForbidden}
                        bounds={this.state.bounds}
                        onStart={(event, uiData) => this.onModalDragStart(event, uiData)}>
                        <div ref={this.draggleRef}>{modal}</div>
                    </Draggable>
                )}>
                {this.props.children}
            </Modal>
        )
    }
}
